import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { getMarketingConsent, setMarketingConsent } from "@/lib/analytics";

export function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Render only after mount to avoid SSR/hydration mismatch.
    if (getMarketingConsent() === "unset") setVisible(true);
  }, []);

  if (!visible) return null;

  function decide(granted: boolean) {
    setMarketingConsent(granted);
    setVisible(false);
  }

  return (
    <div
      role="dialog"
      aria-label="Consentimiento de cookies"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-hairline bg-surface/95 backdrop-blur md:inset-x-auto md:bottom-4 md:left-4 md:max-w-md md:rounded-lg md:border"
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-3 px-4 py-3 md:px-4 md:py-4">
        <p className="text-xs leading-relaxed text-muted-foreground">
          Usamos cookies de medición y marketing (Google Analytics, Meta, TikTok, Clarity)
          para entender cómo se usa el sitio. Puedes aceptar o rechazar.{" "}
          <Link to="/privacy-policy" className="underline hover:text-foreground">
            Más información
          </Link>
          .
        </p>
        <div className="flex justify-end gap-2">
          <Button
            size="sm"
            variant="outline"
            className="border-hairline"
            onClick={() => decide(false)}
          >
            Rechazar
          </Button>
          <Button
            size="sm"
            className="bg-primary text-primary-foreground hover:bg-primary/90"
            onClick={() => decide(true)}
          >
            Aceptar
          </Button>
        </div>
      </div>
    </div>
  );
}
